export class BusinessUnitDto {
    id: number = 0;
    name: string | undefined;
    shortName: string | undefined;
    isActive: boolean | undefined;
    createdBy: string | undefined;
    createdDateTime: Date | undefined;
    modifiedBy: string | undefined;
    modifiedDateTime: Date | undefined
}